import PropTypes from 'prop-types';
import React, { Component } from 'react';
import { injectIntl, defineMessages } from 'react-intl';
import { decorateIntlMessages } from '../common/rosetta_formatted_message';
import classNames from 'classnames';
import { Check, Refresh } from '../common/fa_icons';
import { sendAnalyticsEvent } from '../../utils/analytics';
import { registerEmailSignUp } from '../../utils/registerEmailSignup';

const FORMATTED_MESSAGES = decorateIntlMessages(__filename, defineMessages({
  'placeholder': {
    id: 'placeholder',
    description: 'Placeholder text for the email input.',
    defaultMessage: 'Email Address'
  }
}));

export class FooterEmailAcquisition extends Component {
  constructor(props, context) {
    super(props, context);
    this.state = {
      value: '',
      invalid: false,
      success: false,
      validating: false
    };
  }

  handleChange = (event) => {
    this.setState({
      value: event.target.value,
      invalid: false,
      validating: false
    });
  };

  handleInputClick = (event) => {
    event.stopPropagation();
  };

  handleSubmit = () => {
    this.setState({
      value: '',
      invalid: false,
      validating: true
    });

    registerEmailSignUp({
      email: this.state.value,
      email_list: this.props.newsletter.list,
      source: 'Footer',
      source_type: 'Organic',
      welcome: this.props.newsletter.template
    }, this.context.wordpressApiHost)
      .then(this.handleSubmitSuccess)
      .catch(this.handleSubmitFailure);
  };

  handleSubmitSuccess = () => {
    sendAnalyticsEvent('Email Acquisition', 'Actioned Success', 'Footer');
    this.setState({
      invalid: false,
      success: true,
      validating: false
    });
  };

  handleSubmitFailure = (reason) => {
    this.setState({
      invalid: true,
      success: false,
      validating: false
    });

    sendAnalyticsEvent(
      'Email Acquisition',
      `Actioned Error ${reason.message}`,
      'Footer'
    );
  };

  handleWrapperClick = () => {
    this.emailInput.focus();
  }

  buttonContent = (state) => {
    if (state.success) {
      return <Check />;
    } else if (state.validating) {
      return <span className="spinner" />;
    } else if (state.invalid) {
      return <Refresh />;
    }

    return <span>Go!</span>;
  };

  render() {
    const { invalid, success, validating } = this.state;
    const { formatMessage } = this.props.intl;

    const className = classNames('footer-email-acquisition', {
      invalid,
      success,
      validating
    });

    const placeholderText = formatMessage(FORMATTED_MESSAGES.placeholder);

    return (
      <div className={className} onClick={this.handleWrapperClick}>
        <input className="email-acquisition-input"
          id="email-acquisition"
          ref={(input) => { this.emailInput = input; }}
          placeholder={placeholderText}
          type="email"
          name="email"
          onClick={this.handleInputClick}
          onChange={this.handleChange}
        />
        <button className="email-acquisition-submit" onClick={this.handleSubmit}>
          {this.buttonContent(this.state)}
        </button>
      </div>
    );
  }
}

FooterEmailAcquisition.propTypes = {
  newsletter: PropTypes.shape({
    channel: PropTypes.string.isRequired,
    list: PropTypes.string.isRequired,
    template: PropTypes.string.isRequired
  }).isRequired,
  intl: PropTypes.object.isRequired
};

FooterEmailAcquisition.contextTypes = {
  wordpressApiHost: PropTypes.string
};

export default injectIntl(FooterEmailAcquisition);
